module.exports = __webpack_public_path__ + "static/media/release_notes.f33eec80.md";